module.exports = __webpack_public_path__ + "img/home-bg-img.a54c81e7.webp";